import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/iot/device/list', Object.assign({}, options, { params }));

export const getMeterModelList = (params, options) =>
  request.get('/api/v4ward/iot/device/meterModelList', Object.assign({}, options, { params }));


export const getPage = (params, options) =>
  request.get('/api/v4ward/iot/device/page', Object.assign({}, options, { params }));

export const getChildren = (params, options) =>
request.get('/api/v4ward/iot/device/children', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/iot/device/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/iot/device/remove', qs.stringify(params),options);

export const updateStatus = (params, options) =>
request.post('/api/v4ward/iot/device/statusChange', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/iot/device/submit', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/iot/device/submit', params,options);

export const meterLazyTree = (params, options) =>
  request.get('/api/v4ward/iot/device/lazyTree', Object.assign({}, options, { params }));
